/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { showLogin } from '../../actions/login';
import { Button } from 'reactstrap';

const LoginButton = ({ toggleRequestDemoModal }: { toggleRequestDemoModal: () => void }) => {

  const handleShowLogin = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    showLogin();
  }

  return <>
    <div className='d-flex h-100 align-items-center'>
      <div>
        <Button color='link' className='border-start register-btn' onClick={toggleRequestDemoModal}>
          Contact Us
        </Button>
      </div>
      <div>
        <Button color='primary' className='login-btn mr-3' onClick={handleShowLogin}>
          Login
        </Button>
      </div>
    </div>
  </>
}

export default LoginButton;
